<template>
  <div class="min-h-screen bg-gray-900">
    <!-- Hero Section -->
    <HeroSection />

    <!-- Main Content -->
    <main>
      <!-- Services Section -->
      <ServicesSection />

      <!-- About Section -->
      <AboutSection />

      <!-- Brands Section -->
      <BrandsSection />

      <!-- Contact Section -->
      <ContactSection />
    </main>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import HeroSection from '../components/HeroSection.vue'
import ServicesSection from '../components/ServicesSection.vue'
import AboutSection from '../components/AboutSection.vue'
import BrandsSection from '../components/BrandsSection.vue'
import ContactSection from '../components/ContactSection.vue'

const { t } = useI18n()
</script> 